import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ADMIN_PANEL_URL } from '../../lib/adminRoles';

/** Old in-app /admin/* links (bookmarks, push notifications) land on the standalone admin panel. */
export function AdminRedirect() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const path = pathname.replace(/^\/admin/, '');
    window.location.replace(`${ADMIN_PANEL_URL}${path}${search}`);
  }, [pathname, search]);

  return null;
}
